import EmployeeDashboardWrapper from "components/layouts/EmployeeDashboardWrapper"
import DefBreadcrumb from "components/ui/breadcrumb/DefBreadcrumb"
import Typography from "components/ui/typography"
import { getCMSSegments } from "utils/helper"
import WebinarDetail from "components/cms/WebinarDetail"

const WebinarManagementDetail = () => {
  const segments = getCMSSegments()

  return (
    <EmployeeDashboardWrapper>
      <DefBreadcrumb
        segments={segments}
        prefix="cms"
      />
      <div className="inline-flex items-center">
        <Typography
          variant="subheading4"
          as="h1"
          className="text-primary"
        >
          Pengaturan Detail Webinar
        </Typography>
      </div>
      <WebinarDetail />
    </EmployeeDashboardWrapper>
  )
}

export default WebinarManagementDetail
